import { render, staticRenderFns } from "./Pop.vue?vue&type=template&id=52dad0b0&scoped=true"
import script from "./Pop.vue?vue&type=script&lang=js"
export * from "./Pop.vue?vue&type=script&lang=js"
import style0 from "./Pop.vue?vue&type=style&index=0&id=52dad0b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dad0b0",
  null
  
)

export default component.exports